import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import MetricCardSkeleton from "../MetricCardSkeleton";
import MetricBarChartSkeleton from "../MetricBarChartSkeleton";

interface PeopleMetricsSkeletonProps {
    cardCount?: number;
}

const PeopleMetricsSkeleton = ({
    cardCount = 2,
}: PeopleMetricsSkeletonProps) => {
    return (
        <div className="h-screen">
            <div className="mx-4 space-y-1">
                <Skeleton height={8} width="95%" />
                <Skeleton height={8} width={190} />
            </div>

            <div className="mx-6 mt-2">
                <Skeleton height={10} width="90%" />
            </div>

            <div className="mx-auto px-4 pb-8 pt-4">
                <div className="grid grid-cols-2 gap-4">
                    {Array.from({ length: cardCount }).map((_, index) => (
                        <MetricCardSkeleton
                            key={`people-metric-skeleton-${index}`}
                        />
                    ))}

                    <div className="col-span-2 mt-2 w-full">
                        <MetricBarChartSkeleton
                            height="h-56"
                            barCount={5}
                            labelWidth={160}
                            showMetadataIcon
                            showSubText={false}
                        />
                    </div>

                    {Array.from({ length: cardCount }).map((_, index) => (
                        <MetricCardSkeleton
                            key={`people-metric-skeleton-${index}`}
                        />
                    ))}

                    <div className="col-span-2 mt-2 w-full">
                        <MetricBarChartSkeleton
                            height="h-60"
                            barCount={6}
                            labelWidth={80}
                            showMetadataIcon
                            showSubText
                        />
                    </div>

                    <div className="col-span-2 mt-2 w-full">
                        <MetricBarChartSkeleton
                            height="h-40"
                            barCount={4}
                            labelWidth={100}
                            showMetadataIcon
                            showSubText={false}
                        />
                    </div>

                    <div className="col-span-2 mt-2 w-full">
                        <MetricBarChartSkeleton
                            height="h-40"
                            barCount={4}
                            labelWidth={100}
                            showMetadataIcon
                            showSubText={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PeopleMetricsSkeleton;